<template>
  <div class="g-page">
    <div class="content-container">
      <!-- HEADER -->
      <div class="header-row">
        <div>
          <h2 class="page-title">
            <b-icon icon="pie-chart-fill" class="title-icon"></b-icon>
            Hisobotlar
          </h2>
          <p class="page-sub">Barcha hisobot va analitika sahifalari bir joyda</p>
        </div>
        <div class="header-actions">
          <div class="search-wrapper">
            <b-icon icon="search" class="search-icon"></b-icon>
            <input v-model="filter" type="search" placeholder="Hisobot qidirish..." class="modern-search" />
          </div>
        </div>
      </div>

      <!-- GROUPS -->
      <div v-for="group in filteredGroups" :key="group.title" class="group-block">
        <div class="group-header">
          <div class="group-icon" :style="{ background: group.color + '15', color: group.color }">
            <b-icon :icon="group.icon"></b-icon>
          </div>
          <h3 class="group-title">{{ group.title }}</h3>
          <span class="group-count">{{ group.items.length }} hisobot</span>
        </div>
        <div class="cards-grid">
          <router-link
            v-for="item in group.items"
            :key="item.path"
            :to="item.path"
            class="report-card"
            :class="item.featured ? 'featured' : ''"
          >
            <div class="card-icon" :style="{ background: item.color + '20', color: item.color }">
              <b-icon :icon="item.icon"></b-icon>
            </div>
            <div class="card-body">
              <div class="card-title">
                {{ item.name }}
                <span v-if="item.badge" class="card-badge" :style="{ background: item.badgeBg }">
                  {{ item.badge }}
                </span>
              </div>
              <div class="card-desc">{{ item.desc }}</div>
            </div>
            <b-icon icon="arrow-right" class="card-arrow"></b-icon>
          </router-link>
        </div>
      </div>

      <div v-if="filteredGroups.length === 0" class="empty-state">
        <b-icon icon="search" font-scale="3" class="empty-icon"></b-icon>
        <h4>Hech narsa topilmadi</h4>
        <p>Boshqa kalit so'z bilan qidirib ko'ring</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'XisobotDashboard',
  data() {
    return {
      filter: '',
      groups: [
        {
          title: 'Sotuv va Foyda',
          icon: 'graph-up-arrow',
          color: '#16a34a',
          items: [
            {
              name: 'Foyda-Zarar Hisoboti',
              desc: "Har savdo va xodim bo'yicha foyda-zarar tafsiloti",
              icon: 'graph-up-arrow',
              color: '#16a34a',
              path: '/xisobot/profit-detail',
              featured: true,
              badge: 'YANGI',
              badgeBg: '#16a34a',
            },
            {
              name: 'Xodimlar Savdosi Reytingi',
              desc: 'KPI, qimmat/arzon sotgan xodimlar reytingi',
              icon: 'trophy-fill',
              color: '#f59e0b',
              path: '/xisobot/staff-sales',
              featured: true,
              badge: 'YANGI',
              badgeBg: '#f59e0b',
            },
          ],
        },
        {
          title: 'Xodimlar va Oyliklar',
          icon: 'people-fill',
          color: '#2563eb',
          items: [
            {
              name: 'Xodimlar Balansi va To\'lov',
              desc: "Xodimlar va ustalar KPI balansi, oylik to'lov tavsiyalari",
              icon: 'wallet-fill',
              color: '#2563eb',
              path: '/salary/balance',
              featured: true,
              badge: 'YANGI',
              badgeBg: '#2563eb',
            },
          ],
        },
        {
          title: 'Mahsulotlar',
          icon: 'box-seam',
          color: '#7c3aed',
          items: [
            {
              name: 'Mahsulotlar Hisoboti',
              desc: "Qoldiq, tannarx, sotish narxi, foyda, kam qoldiq filteri",
              icon: 'boxes',
              color: '#2563eb',
              path: '/xisobot/products-inventory',
              featured: true,
              badge: 'YANGI',
              badgeBg: '#2563eb',
            },
            {
              name: 'Mahsulot Brand/Model',
              desc: "Mahsulotlarning brand va modellarini ommaviy tahrirlash",
              icon: 'tags-fill',
              color: '#7c3aed',
              path: '/product-brand-model/index',
            },
          ],
        },
        {
          title: 'Kassa va Pul harakati',
          icon: 'cash-stack',
          color: '#0891b2',
          items: [
            {
              name: 'Kassa Hisoboti',
              desc: "So'm va Dollar joriy qoldiq, kirim/chiqim, kunlik dinamika",
              icon: 'cash-stack',
              color: '#0891b2',
              path: '/xisobot/kassa-summary',
              featured: true,
              badge: 'YANGI',
              badgeBg: '#0891b2',
            },
          ],
        },
        {
          title: 'Eski hisobotlar',
          icon: 'archive-fill',
          color: '#64748b',
          items: [
            {
              name: 'Tugma boshqaruvi (Old)',
              desc: "Eski huquq tizimi orqali hisobotlar — agar yangilarida ma'lumot to'liq ko'rinmasa",
              icon: 'gear-fill',
              color: '#64748b',
              path: '/xisobot/main',
            },
          ],
        },
      ],
    };
  },
  computed: {
    filteredGroups() {
      if (!this.filter) return this.groups;
      const q = this.filter.toLowerCase();
      return this.groups
        .map(g => ({
          ...g,
          items: g.items.filter(i =>
            i.name.toLowerCase().includes(q) ||
            i.desc.toLowerCase().includes(q)
          ),
        }))
        .filter(g => g.items.length > 0);
    },
  },
};
</script>

<style scoped>
.g-page { padding: 24px; height: 100%; overflow-y: auto; background: #f8fafc; }
.content-container { max-width: 1300px; margin: 0 auto; }

.header-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  flex-wrap: wrap;
  gap: 16px;
}

.page-title {
  display: flex; align-items: center; gap: 12px;
  font-size: 26px; font-weight: 800; color: #1e293b; margin: 0;
}
.title-icon { color: #16a34a; font-size: 28px; }
.page-sub {
  font-size: 14px; color: #64748b; margin: 4px 0 0 0;
}

.search-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}
.search-icon {
  position: absolute;
  left: 12px;
  color: #94a3b8;
}
.modern-search {
  background: white;
  border: 1px solid #e2e8f0;
  padding: 10px 14px 10px 38px;
  border-radius: 12px;
  width: 280px;
  outline: none;
  font-size: 14px;
  transition: 0.2s;
  box-shadow: 0 2px 8px rgba(0,0,0,0.04);
}
.modern-search:focus {
  border-color: #16a34a;
  box-shadow: 0 0 0 4px rgba(22,163,74,0.08);
}

/* GROUPS */
.group-block { margin-bottom: 28px; }

.group-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 14px;
}
.group-icon {
  width: 36px; height: 36px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
}
.group-title {
  font-size: 16px;
  font-weight: 800;
  color: #1e293b;
  margin: 0;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.group-count {
  font-size: 12px;
  color: #94a3b8;
  font-weight: 600;
  margin-left: auto;
}

/* CARDS */
.cards-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  gap: 14px;
}

.report-card {
  background: white;
  border-radius: 14px;
  padding: 18px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.05);
  border: 1px solid transparent;
  display: flex;
  align-items: center;
  gap: 14px;
  transition: 0.25s;
  cursor: pointer;
  text-decoration: none !important;
}

.report-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(0,0,0,0.08);
  border-color: #e2e8f0;
}

.report-card.featured {
  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
  border: 1px solid #f0fdf4;
}

.card-icon {
  width: 48px; height: 48px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  flex-shrink: 0;
}

.card-body { flex: 1; min-width: 0; }

.card-title {
  font-size: 15px;
  font-weight: 800;
  color: #1e293b;
  margin: 0 0 4px 0;
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.card-badge {
  padding: 2px 8px;
  border-radius: 999px;
  font-size: 9px;
  font-weight: 800;
  color: white;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.card-desc {
  font-size: 12px;
  color: #64748b;
  line-height: 1.4;
}

.card-arrow {
  color: #94a3b8;
  font-size: 14px;
  transition: 0.2s;
  flex-shrink: 0;
}

.report-card:hover .card-arrow {
  color: #16a34a;
  transform: translateX(3px);
}

/* EMPTY */
.empty-state {
  text-align: center;
  padding: 60px 20px;
  color: #94a3b8;
}
.empty-icon { color: #cbd5e1; margin-bottom: 12px; }
.empty-state h4 { font-size: 18px; font-weight: 700; color: #475569; margin: 0 0 6px 0; }
.empty-state p { font-size: 13px; margin: 0; }
</style>
